import { jsx as t, Fragment as i } from "react/jsx-runtime";
import { useMemo as e } from "react";
import { Tooltip as n } from "@mui/joy";
import { usePermissionsContext as r } from "../hooks/usePermissionsContext.js";
const o = ({ name: o2, hide: s = false, children: m, skip: c = false, fitContent: a = true, sx: h = {}, opacityWhenDisabled: l = 0.3 }) => {
  const { hasPermission: p } = r(), d = "function" == typeof m, f = e(() => !(!c && o2) || (Array.isArray(o2) ? o2.some((t2) => p(t2)) : p(o2)), [o2, p, c]);
  return c || f ? t(i, { children: d ? m(true) : m }) : s ? null : t(n, { title: "У вас немає прав на редагування цієї інформації. Зверніться до адміністратора", sx: { maxWidth: "250px" }, children: t("span", d ? { children: m(false) } : { style: { ...a ? { maxWidth: "fit-content" } : {}, ...h }, children: t("div", { style: { pointerEvents: "none", opacity: l }, children: m }) }) });
};
export {
  o as RequirePermission
};
//# sourceMappingURL=RequirePermission.js.map
